/**
 * @description: 商品盘点盈亏汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="sr-syh-report">
        <div class="syh-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="syh_time">
                        <input type="text" class="form-control laydate-icon" v-model="syh_start_time"> -
                        <input type="text" class="form-control laydate-icon" v-model="syh_end_time">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="syh_shop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-2">仓库:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="syh_stock" data-placeholder="请选择仓库">
                    </select>
                </div>
                <label class="list-label-4">商品类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="syh_goods_type" data-placeholder="请选择商品类型"></select>
                </div>
            </div>
            <div class="row">
                <label class="list-label-4">商品名称:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入商品名称" v-model="syh_goods_name">
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="initSyhTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getSyhExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="syh_list"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="syhExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='syhExport_allcheck' @click='syhExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='syhExport_checkModel' value="store_name">
                            <label>仓库</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='syhExport_checkModel' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='syhExport_checkModel' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='syhExport_checkModel' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='syhExport_checkModel' value="discount_price">
                            <label>销售单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='syhExport_checkModel' value="buying_price">
                            <label>进货单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='syhExport_checkModel' value="profit">
                            <label>盈余</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='syhExport_checkModel' value="loss">
                            <label>亏空</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='syhExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='syhExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                syh_start_time: "",
                syh_end_time: "",
                syh_goods_name: "",
                syhExport_allcheck: false,
                c_syhExport_allcheck: false,
                syhExport_checkModel: [],
                syhExport_checkData: ['store_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'discount_price', 'buying_price', 'profit', 'loss'],
                syhExport_type: 1,
            }
        },
        watch: {
            syhExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.syhExport_checkModel.length >= this.syhExport_checkData.length) {
                        this.syhExport_allcheck = true;
                        this.c_syhExport_allcheck = true;
                    } else {
                        this.syhExport_allcheck = false;
                        this.c_syhExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.syh_start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.syh_end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput();  // 门店
            this.getGoodsType(); // 商品类型
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.syh_time).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    }
                }, function(start, end, label) {
                    _this.syh_start_time = start.format('YYYY-MM-DD HH:mm');
                    _this.syh_end_time = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.syh_shop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    _this.initi_list_box('');
                                    $(_this.$refs.syh_stock).prop("disabled", true);
                                    return;
                                }
                                $(_this.$refs.syh_stock).prop("disabled", false);
                                _this.getstockdata(e.params.data.id);
                            });
                            $(_this.$refs.syh_shop).val(data.response.result[1].id).trigger('change');
                            $(_this.$refs.syh_stock).prop("disabled", false);
                            $(_this.$refs.syh_stock).val('').trigger('change');
                            _this.getstockdata(data.response.result[1].id);
                            _this.initSyhTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 仓库数据
            getstockdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getStoreList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let boxdatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                boxdatas.push({ id: v.id, text: v.name });
                            });
                            _this.initi_list_box(boxdatas);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            initi_list_box: function(boxdatas) {
                $(this.$refs.syh_stock).html("");
                $(this.$refs.syh_stock).select2({
                    data: boxdatas,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
            },
            // 获取商品类型
            getGoodsType: function() {
                const _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": []
                };
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let result = data.response.result.data;
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.syh_goods_type).html("");
                            $(_this.$refs.syh_goods_type).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },



            // 表格
            initSyhTable: function() {
                let _this = this;
                $(_this.$refs.syh_list).bootstrapTable('destroy');
                $(_this.$refs.syh_list).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getSyhList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "store_name",
                        title: "仓库",
                        width: "7%",
                        valign: "middle"
                    }, {
                        field: "goods_type_name",
                        title: "商品类型",
                        width: "7%",
                        valign: "middle"
                    }, {
                        field: "goods_name",
                        title: "商品名称",
                        width: "10%",
                        valign: "middle"
                    }, {
                        field: "goods_unit_name",
                        title: "单位",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "discount_price",
                        title: "销售单价",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "buying_price",
                        title: "进货单价",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "profit",
                        title: "盈余",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "loss",
                        title: "亏空",
                        width: "6%",
                        valign: "middle"
                    }],
                });
            },
            getSyhList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.syh_start_time,
                            "end_time": _this.syh_end_time,
                            "shop_id": $(_this.$refs.syh_shop).val(),
                            "store_id": $.trim($(_this.$refs.syh_stock).val()),
                            "goods_type": $.trim($(_this.$refs.syh_goods_type).val()),
                            "goods_name": _this.syh_goods_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport2/getStocktakingSummary",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.data.total,
                                rows: data.response.data.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getSyhExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/stocktakingSummaryExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.syhExport_checkModel = data.response.result.export_fields;
                                _this.syhExport_type = data.response.result.export_type;
                            } else {
                                _this.syhExport_checkModel = _this.syhExport_checkData;
                                _this.syhExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.syhExport_alert)
                }, function() {
                    _this.exportSyhList();
                });
            },
            // 导出字段全选
            syhExportCheckedAll: function() {
                let _this = this;
                _this.syhExport_allcheck = _this.c_syhExport_allcheck;
                if(!_this.syhExport_allcheck) { // 实现全选
                    _this.syhExport_checkModel = [];
                    _this.syhExport_checkData.forEach(function(item) {
                        _this.syhExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.syhExport_checkModel = [];
                }
            },
            // 点击“导出”按钮
            exportSyhList: function() {
                let _this = this;

                let export_fields = JSON.stringify(_this.syhExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport2/stocktakingSummaryExport" +
                    "?start_time=" + _this.syh_start_time +
                    "&end_time=" + _this.syh_end_time +
                    "&shop_id=" + $(_this.$refs.syh_shop).val() +
                    "&store_id=" + $.trim($(_this.$refs.syh_stock).val()) +
                    "&goods_type=" + $.trim($(_this.$refs.syh_goods_type).val()) +
                    "&goods_name=" + _this.syh_goods_name +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.syhExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>